// extracted by mini-css-extract-plugin
export var csatScore = "_ka-5";
export var header = "_ka-1";
export var panelWrapper = "_ka-2";
export var postPreview = "_ka-3";
export var rightContent = "_ka-0";
export var wrappingText = "_ka-4";